import React from 'react';

export const Svg = ({ size, colour, type, rotation, ...otherProps }) => {
  return (
    <div className="mz-svg-wrapper" {...otherProps}>
      <i
        style={{ fontSize: size + 'rem' }}
        className={[
          'mz-svg',
          colour ? `mz-svg--${colour}` : '',
          type ? `mz-svg-${type}` : '',
          rotation ? `mz-svg--rotate${rotation}` : '',
        ].join(' ')}></i>
    </div>
  );
};